import Icon from '@material-ui/icons/Label'
import React from 'react'
import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    EditButton,
    Filter,
    List,
    required,
    SearchInput,
    SelectInput,
    SimpleForm,
    TextField as TextFieldRa,
    TextInput
} from 'react-admin'
import { useLocation } from 'react-router-dom'

export const ProductFareAgeIcon = Icon

const ProductFareAgeFilter = (props) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
    </Filter>
)
export const ProductFareAgeList = ({ permissions, ...props }) => {
    return (
        <List
            {...props}
            exporter={false}
            title="ProductFareAges"
            bulkActionButtons={false}
            sort={{ field: 'name', order: 'ASC' }}
            filters={<ProductFareAgeFilter />}
            perPage={25}
        >
            <Datagrid>
                <TextFieldRa source="name" label="Nome" />
                <EditButton label="" />
                <DeleteButton label="" />
            </Datagrid>
        </List>
    )
}

const currencyBRL = (value) => {
    value = value.replace('.', '')
    return value
}

export const ProductFareAgeEdit = (props) => {
    const redirect = (basePath, id, data) => `/admin/products/${data.productId}/show/1`

    return (
        <Edit {...props} mutationMode="pessimistic">
            <SimpleForm redirect={redirect}>
                <TextInput
                    label="Idade Inicial"
                    source="startAge"
                    validate={[required()]}
                />
                <TextInput
                    label="Idade Final"
                    source="endAge"
                    validate={[required()]}
                />
                <TextInput
                    label="Valor"
                    source="value"
                    validate={[required()]}
                    parse={currencyBRL}
                />
                {/* <TextInput
                    label="Moeda"
                    source="currency"
                    validate={[required()]}
                /> */}
                <SelectInput
                    label="Moeda"
                    source="currency"
                    choices={[
                            { id: "USD", name: 'Dólar (USD, US$)' },
                            { id: "BRL", name: 'Reais (BRL, R$)' },
                            // { id: "EUR", name: 'Euros (EUR, €)' },
                            ]}
                    validate={[required()]}
                />  
            </SimpleForm>
        </Edit>
    )
}

export const ProductFareAgeCreate = (props) => {
    const location = useLocation()

    const redirect = (basePath, id, data) => `/admin/products/${data.productId}/show/1`

    const transform = (data) => ({
        ...data,
        productId: location.state.productId,
    })

    return (
        <Create {...props} mutationMode="pessimistic" transform={transform}>
            <SimpleForm redirect={redirect}>
                <TextInput
                    label="Idade Inicial"
                    source="startAge"
                    validate={[required()]}
                />
                <TextInput
                    label="Idade Final"
                    source="endAge"
                    validate={[required()]}
                />
                <TextInput
                    label="Valor"
                    source="value"
                    validate={[required()]}
                    parse={currencyBRL}
                />
                {/* <TextInput
                    label="Moeda"
                    source="currency"
                    validate={[required()]}
                /> */}
                <SelectInput
                    label="Moeda"
                    source="currency"
                    choices={[
                            { id: "USD", name: 'Dólar (USD, US$)' },
                            { id: "BRL", name: 'Reais (BRL, R$)' },
                            // { id: "EUR", name: 'Euros (EUR, €)' },
                            ]}
                    validate={[required()]}
                />  
            </SimpleForm>
        </Create>
    )
}
